import { useState } from 'react';
import { AccountFilter } from '../../../../shared/types/modules/account';
import { LayoutModule } from '../../../layout/modules';
import { SarlaftFilters } from './filters';
import { SarlaftList } from './list';

export const Sarlaft = () => {
    const [filters, setFilters] = useState<AccountFilter>();

    return (
        <>
            <LayoutModule title="Búsqueda de casos SARLAFT">
                <SarlaftFilters onFilter={(filters) => setFilters(filters)} />
            </LayoutModule>
            <SarlaftList filters={filters} />
        </>
    );
};
